export const TesseractLanguageCodes = {
    Afrikan: "afr",
    Amharic: "amh",
    Arabic: "ara",
    Assamese: "asm",
    Azerbaijani: "aze",
    AzerbaijaniCyrillic: "aze_cyrl",
    Belarusian: "bel",
    Bengali: "ben",
    Tibetan: "bod",
    Bosnian: "bos",
    Bulgarian: "bul",
    Catalan: "cat",
    Cebuano: "ceb",
    Czech: "ces",
    ChineseSimplified: "chi_sim",
    ChineseTraditional: "chi_tra",
    Cherokee: "chr",
    Welsh: "cym",
    Danish: "dan",
    German: "deu",
    Dzongkha: "dzo",
    GreekModern: "ell",
    English: "eng",
    EnglishMiddle: "enm",
    Esperanto: "epo",
    Estonian: "est",
    Basque: "eus",
    Persian: "fas",
    Finnish: "fin",
    French: "fra",
    GermanFraktur: "frk",
    FrenchMiddle: "frm",
    Irish: "gle",
    Galician: "glg",
    GreekAncient: "grc",
    Gujarati: "guj",
    HaitianCreole: "hat",
    Hebrew: "heb",
    Hindi: "hin",
    Croatian: "hrv",
    Hungarian: "hun",
    Inuktitut: "iku",
    Indonesian: "ind",
    Icelandic: "isl",
    Italian: "ita",
    ItalianOld: "ita_old",
    Javanese: "jav",
    Japanese: "jpn",
    Kannada: "kan",
    Georgian: "kat",
    GeorgianOld: "kat_old",
    Kazakh: "kaz",
    CentralKhmer: "khm",
    KirghizKyrgyz: "kir",
    Korean: "kor",
    Kurdish: "kur",
    Lao: "lao",
    Latin: "lat",
    Latvian: "lav",
    Lithuanian: "lit",
    Malayalam: "mal",
    Marathi: "mar",
    Macedonian: "mkd",
    Maltese: "mlt",
    Malay: "msa",
    Burmese: "mya",
    Nepali: "nep",
    DutchFlemish: "nld",
    Norwegian: "nor",
    Oriya: "ori",
    PanjabiPunjabi: "pan",
    Polish: "pol",
    Portuguese: "por",
    PushtoPashto: "pus",
    RomanianMoldavianMoldovan: "ron",
    Russian: "rus",
    Sanskrit: "san",
    SinhalaSinhalese: "sin",
    Slovak: "slk",
    Slovenian: "slv",
    SpanishCastilian: "spa",
    SpanishCastilianOld: "spa_old",
    Albanian: "sqi",
    Serbian: "srp",
    SerbianLatin: "srp_latn",
    Swahili: "swa",
    Swedish: "swe",
    Syriac: "syr",
    Tamil: "tam",
    Telugu: "tel",
    Tajik: "tgk",
    Tagalog: "tgl",
    Thai: "tha",
    Tigrinya: "tir",
    Turkish: "tur",
    UighurUyghur: "uig",
    Ukrainian: "ukr",
    Urdu: "urd",
    Uzbek: "uzb",
    UzbekCyrillic: "uzb_cyrl",
    Vietnamese: "vie",
    Yiddish: "yid"
} as const;

export type TesseractLangCode = typeof TesseractLanguageCodes[keyof typeof TesseractLanguageCodes];

export type OCRService = 'tesseract' | 'groq' | 'custom';